import axios from 'axios'
import url from './base-url';
const api = axios.create({
    baseURL: url
});
function Headers(auth) {
    return {headers:{ 'x-access-token': auth,'Content-Type': 'application/json'}};
}
export const getOrderNav = (userId,auth) => api.get(`/orders/navigation/${userId}`,Headers(auth));
export const updateItemsbasedOnStores = (userId, text,payload,auth) => api.put(`/orders/navigation/${userId}/${text}`,payload,Headers(auth));
export const updateSelectedAndExpandedItembyId = (userId, payload,auth) => api.patch(`/orders/navigation/${userId}`, payload,Headers(auth));
export const updateBagde = (userId,auth) => api.put(`/orders/navigation/badge/${userId}/update`,Headers(auth));
const apis  = {
    getOrderNav,
    updateItemsbasedOnStores,
    updateSelectedAndExpandedItembyId,
    updateBagde
}
export default apis;